import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';
import backupImage from '../assets/backup.jpg';

const ProductCard = ({ product }) => {
  const imageUrl = product.images?.[0] || backupImage;

  return (
    <Link to={`/product/${product.id_product}`} className="product-card-link">
      <div className="product-card">
        <div className="product-image-container">
          <img src={imageUrl} alt={product.name} className="product-image" />
        </div>
        <div className="product-info">
          <p className="product-price">${product.price.toLocaleString('es-AR')}</p>
          <h3 className="product-name">{product.name}</h3>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;